import getEwsRequestDateString from './utils/getEwsRequestDateString';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import folderIdFactory from 'owa-service/lib/factory/folderId';
import itemId from 'owa-service/lib/factory/itemId';
import targetFolderIdFactory from 'owa-service/lib/factory/targetFolderId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Create a ConversationAction with move params for a given conversation.
 * @param conversationContext the conversation context to be moved
 * @param currentFolderTargetId - the table view the conversations are moving from (null for search)
 * @param destinationFolderTargetId - the folder they need to go to
 */
function createMoveConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId) {
    return conversationAction({
        Action: 'Move',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        ContextFolderId: currentFolderTargetId,
        DestinationFolderId: destinationFolderTargetId,
        ConversationLastSyncTime: getEwsRequestDateString(conversationContext.conversationLastSyncTimeStamp),
    });
}
/**
 * Worker method which converts the provided data into an ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be moved
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, destinationFolderId, currentFolderId) {
    var destinationFolderTargetId = targetFolderIdFactory({
        BaseFolderId: folderIdFactory({ Id: destinationFolderId }),
    });
    // This is a workaround for the fact that in search scenarios we need to pass a completely null ContextFolderId
    // (not the BaseFolderId form in the false condition of the ternary) in all conversationActions.
    var currentFolderTargetId = currentFolderId == null
        ? null
        : targetFolderIdFactory({ BaseFolderId: folderIdFactory({ Id: currentFolderId }) });
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createMoveConversationAction(conversationContext, currentFolderTargetId, destinationFolderTargetId);
    });
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: true,
    });
}
/**
 * The service which calls the ApplyConversationAction with move parameters.
 * @param conversationContexts the conversation contexts to be moved
 * @param destinationFolderId - the folder they need to move to
 * @param currentFolderId - the folder they originate in -- null for search scenarios
 */
export default function moveConversationService(conversationContexts, destinationFolderId, currentFolderId) {
    var requestBody = configureRequestBody(conversationContexts, destinationFolderId, currentFolderId);
    // Work Item 27629: Remove workaround for timezone issue (sending requests in UTC time zone)
    var jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return applyConversationActionOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=moveConversationService.js.map